function initLottie() {
	if (typeof window.lottie === "undefined") return;

	const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

	document.querySelectorAll("[data-lottie]:not([data-lottie-init])").forEach((el) => {
		el.dataset.lottieInit = "true";

		const animation = window.lottie.loadAnimation({
			container: el,
			renderer: "svg",
			loop: el.dataset.lottieLoop === "1",
			autoplay: false,
			path: el.dataset.lottie,
			rendererSettings: { preserveAspectRatio: el.dataset.lottieFit || "xMidYMin slice" },
		});

		animation.addEventListener("DOMLoaded", () => {
			if (reduce) {
				animation.goToAndStop(animation.totalFrames - 1, true);
				return;
			}

			new IntersectionObserver(
				(entries) => entries.forEach((entry) => (entry.isIntersecting ? animation.play() : animation.pause())),
				{ threshold: 0.2 }
			).observe(el);
		});
	});
}

if (document.readyState === "complete") {
	initLottie();
} else {
	window.addEventListener("load", initLottie);
}
